<template>
  <div style="position: relative">
    <h3 style="margin: 15px; text-align: center">
      Bank Detail
      <v-btn
        icon
        absolute
        v-if="!isEditStoreList && store_detail.store_bank.length > 0"
        style="top: -5px; right: 15px"
        @click="toEdit(0)"
      >
        <v-icon color="black">edit</v-icon>
      </v-btn>
      <v-btn
        icon
        absolute
        v-else-if="!isEditStoreList"
        style="top: -5px; right: 15px"
        @click="toAdd()"
      >
        <v-icon color="black">add</v-icon>
      </v-btn>
    </h3>
    <hr style="margin: 0 15px" />
    <div
      class="body__container"
      v-for="(info, index) in store_detail.store_bank"
      :key="index"
    >
      <div class="style-title-detail">
        Account name:
        <span class="style-data-detail">{{
          info.store_bank_account_name
        }}</span>
      </div>
      <div class="style-title-detail">
        Account number:
        <span class="style-data-detail">{{
          info.store_bank_account_number
        }}</span>
      </div>
      <div class="style-title-detail">
        Bank name:
        <span class="style-data-detail">{{
          info.store_bank_bank_id.thbk_name_th
        }}</span>
      </div>
      <div class="style-title-detail">
        Type:
        <span class="style-data-detail">{{
          info.store_bank_type == 2 ? "บุคคลทั่วไป" : "นิติบุคคล"
        }}</span>
      </div>
      <div class="style-title-detail">
        Image:
        <a
          :href="info.store_bank_image"
          target="_blank"
          style="text-decoration: none"
        >
          <v-btn depressed small color="#e0e0e0">
            <v-icon small>image</v-icon>Preview
          </v-btn>
        </a>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title
          class="py-2"
          style="
            display: flex;
            font-size: 22px;
            background-color: black;
            color: white;
          "
          >{{ selectedIndex == -1 ? "Add Bank Detail" : "Edit Bank Detail "
          }}<v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" :disabled="isLoading">
            <v-icon color="white">close</v-icon></v-btn
          ></v-card-title
        ><v-card-text style="max-height: 60vh; overflow: auto">
          <v-form ref="form" v-model="valid">
            <v-radio-group v-model="form.store_bank_type" row
              ><v-radio :value="2" color="black" label="บุคคลทั่วไป"></v-radio
              ><v-radio :value="1" color="black" label="นิติบุคคล"></v-radio
            ></v-radio-group>
            <v-text-field
              label="Account name"
              v-model="form.store_bank_account_name"
              :rules="[(v) => !!v || 'required']"
            ></v-text-field>
            <v-text-field
              type="number"
              label="Account number"
              v-model="form.store_bank_account_number"
              :rules="[(v) => !!v || 'required']"
            ></v-text-field>
            <v-select
              :items="thaiBankList"
              item-text="thbk_name_th"
              item-value="id"
              v-model="form.store_bank_bank_id"
            ></v-select>
            <div style="position: relative; text-align: center">
              <div
                style="display: flex; align-items: center; margin-bottom: 20px"
              >
                <span>Bank Image</span>
                <v-divider vertical class="mx-3"></v-divider>
                <v-btn
                  icon
                  @click="$refs.imageInput.click()"
                  color="black"
                  style="color: white"
                >
                  <v-icon
                    small
                    v-if="form.store_bank_image != null || imgSrc != null"
                  >
                    edit
                  </v-icon>
                  <v-icon small v-else>add</v-icon>
                </v-btn>
              </div>
              <input
                style="display: none"
                type="file"
                @change="onImageSelected"
                ref="imageInput"
                accept="image/*"
              />
              <a
                :href="form.store_bank_image"
                target="_blank"
                v-if="form.store_bank_image != null || imgSrc != null"
              >
                <v-img :src="imgSrc" v-if="imgSrc != null"></v-img>
                <v-img
                  :src="form.store_bank_image"
                  v-else-if="form.store_bank_image != null"
                ></v-img
              ></a>

              <div
                style="
                  height: 200px;
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 20px;
                "
              >
                No image avaliable
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn
            :loading="isLoading"
            @click="save()"
            color="black"
            width="400px"
            style="color: white"
            >save</v-btn
          ><v-spacer></v-spacer
        ></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  props: ["store_detail"],
  data() {
    return {
      valid: true,
      imgSrc: null,
      dialog: false,
      isLoading: false,
      form: {},
      selectedIndex: -1,
    };
  },
  async created() {
    this.fetchBankList();
  },
  computed: {
    ...mapState({
      thaiBankList: (state) => state.fetchDefaultRider.thai_bank,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    ...mapActions({
      editStoreBankDetail: "fetchStoreBack/editStoreBankDetail",
      createStoreBankDetail: "fetchStoreBack/createStoreBankDetail",
      fetchBankList: "fetchDefaultRider/getThaiBank",
    }),
    resetForm() {
      this.form = {
        store_bank_account_name: "",
        store_bank_account_number: "",
        store_bank_bank_id: 1,
        store_bank_store_id: this.store_detail.store.store_id,
        store_bank_type: 2,
        store_bank_image: null,
      };
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      let _this = this;
      reader.addEventListener("load", () => {
        _this.imgSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    toEdit(index) {
      this.resetForm();
      this.imgSrc = null;
      let cloneForm = JSON.parse(
        JSON.stringify(this.store_detail.store_bank[0])
      );
      cloneForm.store_bank_bank_id = cloneForm.store_bank_bank_id.id;
      this.form = cloneForm;

      // this.form.store_bank_store_id = this.store_detail.store_bank[0].store_id
      this.selectedIndex = index;
      this.dialog = true;
    },
    toAdd() {
      this.resetForm();
      this.$refs.form.resetValidation();
      this.imgSrc = null;
      this.dialog = true;
      this.selectedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        if (this.imgSrc != null) {
          this.form.store_bank_image = this.imgSrc;
        } else {
          delete this.form.store_bank_image;
        }
        let result;
        if (this.selectedIndex == -1) {
          result = await this.createStoreBankDetail({
            province: this.$route.params.province,
            form: this.form,
          });
          //add
        } else {
          result = await this.editStoreBankDetail({
            province: this.$route.params.province,
            form: this.form,
          });
          //edit
        }
        if (result === true) {
          await this.$store.dispatch(
            "fetchStoreBack/getStoreDetail",
            this.$route.params.store_id
          );
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>

<style  scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}

.body__container {
  padding: 15px;
}
</style>